// components
import { Stack, useMediaQuery } from '@mui/material';
import { StyledBoxFullWidth } from 'components/shared/Box/Box.styles';
import PlanUnitSelector from 'components/shared/PlanUnitSelector';

import {
  StyledCustomScrollbarBoxNoBg,
  StyledLeftGridContainer
} from './QualityMonitor.styles';
import OpenRequests from './OpenRequests';
import QualityMonitorStyles from './QualityMonitorStyles';
import TasksList from './TasksList';

// hooks
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'hooks';
import { useDateNavigationHoursStore } from 'components/shared/DateNavigation/DateNavigationHours.stores';

// types
import { PlanUnitMix } from 'components/types';
import { TabType } from '../Home.enums';
import { QualityMonitorProps } from './QualityMonitor.types';

// utils
import dayjs from 'dayjs';
import { setLastUsedPlanunit } from './actionCreators';

export default function QualityMonitor({
  setPage,
  setIsLoading
}: QualityMonitorProps) {
  const { hasRosterPortalPlanModusAccess, hasRosterPortalMessagesAccess } =
    useSelector((state) => state.grants);

  const dispatch = useDispatch();
  const [lastUsedPlanunit] = useSelector(
    (state) => state.roster.home.qualityMonitor.lastUsedPlanunit
  );
  const [selectedPlanUnits, setSelectedPlanUnits] = useState<PlanUnitMix[]>([]);
  const [isLoadingOpenRequests, setIsLoadingOpenRequests] = useState(false);
  const [isLoadingTasks, setIsLoadingTasks] = useState(false);
  const [amountOfOpenDuties, setAmountOfOpenDuties] = useState<number | null>(
    null
  );
  const { setSelectedDate } = useDateNavigationHoursStore((state) => state);

  const isSmallerThanExpanded = useMediaQuery((theme) =>
    theme.breakpoints.down('expanded')
  );

  const containerRef = useRef<HTMLDivElement>(null);

  const onPlanunitSelected = useCallback(
    (value: PlanUnitMix[]) => {
      setSelectedPlanUnits(value);
      dispatch(setLastUsedPlanunit(value));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!isLoadingOpenRequests && !isLoadingTasks) {
      setIsLoading(false);
    }
    if (isLoadingOpenRequests || isLoadingTasks) {
      setIsLoading(true);
    }
  }, [isLoadingOpenRequests, isLoadingTasks, setIsLoading]);

  return (
    <QualityMonitorStyles>
      <PlanUnitSelector
        onSelected={onPlanunitSelected}
        firstOptionIsDefault
        defaultValue={lastUsedPlanunit ? [lastUsedPlanunit] : undefined}
      />
      <Stack direction={isSmallerThanExpanded ? 'column' : 'row'} gap={4}>
        {hasRosterPortalMessagesAccess && (
          <StyledLeftGridContainer container spacing={4} ref={containerRef}>
            {hasRosterPortalMessagesAccess && (
              <TasksList
                selectedPlanUnits={selectedPlanUnits}
                openTab={(
                  tabType: TabType,
                  payload?: { [key: string]: any }
                ) => {
                  if (
                    (tabType === TabType.TRAVEL_EXPENSE_CLAIMS ||
                      tabType === TabType.TRAVEL_MOVEMENTS) &&
                    payload?.dateOfMonth
                  ) {
                    setSelectedDate(dayjs(payload?.dateOfMonth).toDate());
                  }

                  setPage(tabType);
                }}
                setIsLoading={setIsLoadingTasks}
                containerRef={containerRef}
                amountOfOpenDuties={amountOfOpenDuties}
              />
            )}
          </StyledLeftGridContainer>
        )}

        <StyledBoxFullWidth>
          <StyledCustomScrollbarBoxNoBg>
            {hasRosterPortalPlanModusAccess && (
              <OpenRequests
                selectedPlanUnits={selectedPlanUnits}
                setIsLoading={setIsLoadingOpenRequests}
                setAmountOfOpenDuties={setAmountOfOpenDuties}
              />
            )}
          </StyledCustomScrollbarBoxNoBg>
        </StyledBoxFullWidth>
      </Stack>
    </QualityMonitorStyles>
  );
}
